export const PAGINATION = {
    DEFAULT_PAGE_SIZE_10: 10,
    DEFAULT_PAGE_SIZE_16: 16,
    DEFAULT_PAGE_SIZE_20: 20,
    DEFAULT_PAGE_SIZE_100: 100,
    DEFAULT_START_PAGE_1: 1,
  };
